import { render, staticRenderFns } from "./EditSchools.vue?vue&type=template&id=15ba7af0"
import script from "./EditSchools.vue?vue&type=script&lang=js"
export * from "./EditSchools.vue?vue&type=script&lang=js"
import style0 from "./EditSchools.vue?vue&type=style&index=0&id=15ba7af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports